import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import QRCode from "react-qr-code";
import api, { formatApiError } from "@/lib/api";
import { Navbar } from "@/components/Navbar";
import { PAGE, BTN_GHOST, ICON_BTN } from "@/lib/styles";
import { ArrowLeft, RefreshCw } from "lucide-react";
import { toast } from "sonner";

export default function LinkDevice() {
  const navigate = useNavigate();
  const [code, setCode] = useState("");
  const [seconds, setSeconds] = useState(0);

  const start = useCallback(async () => {
    try {
      const { data } = await api.post("/auth/pair/start");
      setCode(data.code);
      setSeconds(data.expires_in);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
  }, []);

  useEffect(() => { start(); }, [start]);

  useEffect(() => {
    if (seconds <= 0) return;
    const t = setInterval(() => setSeconds((s) => s - 1), 1000);
    return () => clearInterval(t);
  }, [seconds]);

  const pairUrl = `${window.location.origin}/pair?code=${code}`;

  return (
    <div className={`${PAGE} font-body`}>
      <Navbar />
      <div className="max-w-lg mx-auto p-6 md:p-10">
        <button onClick={() => navigate("/")} className={ICON_BTN} data-testid="back-button"><ArrowLeft size={18} /></button>
        <h1 className="font-heading font-light text-3xl sm:text-4xl tracking-tight mt-6 mb-2">Vincular dispositivo</h1>
        <p className="font-body text-sm text-slate-500 dark:text-slate-400 mb-8">
          En tu otro dispositivo abre Notacora → Vincular y escanea este código QR (o escribe el código). Se conectará a tu misma cuenta, como WhatsApp Web.
        </p>

        <div className="bg-slate-50 dark:bg-slate-900/50 border border-slate-200 dark:border-slate-800 rounded-2xl p-8 flex flex-col items-center gap-5">
          {code ? (
            <div className="bg-white p-4 rounded-xl" data-testid="pair-qr">
              <QRCode value={pairUrl} size={200} />
            </div>
          ) : (
            <p className="font-mono2 text-sm text-slate-400">Generando código...</p>
          )}
          <div className="w-full">
            <p className="font-mono2 text-[11px] text-center text-slate-400 mb-1.5">Código manual</p>
            <p className="font-mono2 text-xs bg-white dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-lg px-3 py-2.5 break-all text-center" data-testid="pair-code">
              {code || "..."}
            </p>
          </div>
          <p className="font-mono2 text-xs text-slate-400">{!code ? "Generando código..." : seconds > 0 ? `Expira en ${seconds}s` : "Código expirado"}</p>
          <button onClick={start} className={BTN_GHOST} data-testid="pair-refresh">
            <RefreshCw size={15} /> Generar nuevo
          </button>
        </div>
      </div>
    </div>
  );
}
